import React from 'react';
import { Typography } from '@mui/material';
import { ClassDetails } from './classDetails';


const ClassesList = ({ classSchedule, live, dashboardState,  handleEnrolledCourse, convertToLocalStartTime, convertToLocalEndTime, isCoursePage }) => {
  const classSchedulesJSX = [];
  const hasActiveClasses = Object.values(classSchedule || {}).some(classDetails => classDetails.status === 'active');

  if (live && !hasActiveClasses) {
    return <Typography>No schedules available</Typography>;
  }

  classSchedule && Object.entries(classSchedule).forEach(([classId, classDetails]) => {
    if (!classDetails.times) {
      return
    }
    if (live && !dashboardState && classDetails.status !== 'active') {
      return; // Skip inactive classes
    }

    classSchedulesJSX.push(
      <ClassDetails
        key={classId}
        classId={classId}
        classDetails={classDetails}
        live={live}
        dashboardState={dashboardState}
        isCoursePage={isCoursePage}
        handleEnrolledCourse={handleEnrolledCourse}
        convertToLocalStartTime={convertToLocalStartTime}
        convertToLocalEndTime={convertToLocalEndTime}
      />
    );
  });
  if (classSchedulesJSX.length === 0) {
    return <Typography>No schedules available</Typography>;
  }

  return <>{classSchedulesJSX}</>;
};

export default ClassesList;
